export default function () {

  window.debug('debug: init storage');

  function dbConnect() {
    return indexedDB.open('perkinsdb', 2);
    window.debug('debug: connecting to db');
  }

  function deleteRow(key) {
    let con = dbConnect();

    con.onsuccess = function (event) {
      const db = event.target.result;

      const transaction = db.transaction(['contacts'], 'readwrite')
        .objectStore('contacts')
        .delete(key);

      transaction.onsuccess = (event) => {
        window.debug('debug:' + key + ' deleted.');
        window.getCount();
      };
    }
  }

  window.getCount = function () {
    const con = dbConnect();

    con.onupgradeneeded = function (event) {
      const db = event.target.result;
      if (!db.objectStoreNames.contains('contacts')) {
        db.createObjectStore('contacts', { autoIncrement: true });
      }
    };

    con.onsuccess = function (event) {
      const db = event.target.result;
      const transaction = db.transaction('contacts', 'readonly').objectStore('contacts');
      const countRequest = transaction.count();

      countRequest.onsuccess = function (event) {
        const counterElement = document.getElementById('data-counter');
        if (counterElement) {
          counterElement.textContent = countRequest.result;
        } else {
          window.debug('debug: data-counter element not found');
        }

        return countRequest.result;
      }
    }
  }

  window.storeDataLocally = function (data) {
    return new Promise((resolve, reject) => {
      let con = dbConnect();

      con.onupgradeneeded = function (event) {
        const db = event.target.result;
        if (!db.objectStoreNames.contains('contacts')) {
          db.createObjectStore('contacts', { autoIncrement: true });
        }
      };

      con.onsuccess = function (event) {
        const db = event.target.result;
        const transaction = db.transaction('contacts', 'readwrite');
        const store = transaction.objectStore('contacts');
        const request = store.add(data);
        
        request.onsuccess = function() {
          window.debug('debug: inserted');
          window.debug(data);
          resolve();
        };
        
        request.onerror = function(event) {
          window.debug('debug: error inserting data');
          window.debug(event);
          reject(event);
        };
      };
      
      con.onerror = function(event) {
        window.debug('debug: error connecting to database');
        window.debug(event);
        reject(event);
      };
    });
  }

  window.uploadData = function () {
    let con = dbConnect();

    con.onupgradeneeded = function (event) {
      const db = event.target.result;
      if (!db.objectStoreNames.contains('contacts')) {
        db.createObjectStore('contacts', { autoIncrement: true });
      }
    };

    con.onerror = (event) => {
      alert(`Database error: ${event.target.errorCode}`);
    };

    con.onsuccess = function (event) {
      const db = event.target.result;
      const transaction = db.transaction(['contacts']);
      const store = transaction.objectStore('contacts');

      window.debug('debug: looping data');
      store.openCursor().onsuccess = (event) => {
        const cursor = event.target.result;
        if (cursor) {
          window.debug('debug: uploading ' + cursor.key);

          sendDataToServer(cursor.key,cursor.value);

          cursor.continue();
        } else {
          window.debug('debug: end of data');
        }
      };
    };
  }

  async function sendDataToServer(key, value) {

    const csrf = document.querySelector('meta[name="csrf-token"]').content;

    console.log(csrf);

    var formData = new FormData();
    formData.append('name', value.name);
    formData.append('surname', value.surname);
    formData.append('email', value.email);
    formData.append('country', value.country);
    formData.append('consent', value.consent);
    formData.append('marketing', value.marketing);
    formData.append('when', value.when);
    formData.append('csrf_token', csrf);

    // Send form data using POST to endpoint /form
    fetch('/form/', {
        method: 'POST',
        body: formData
    }).then(function(response) {
        if (response.ok) {
          window.debug('debug: send success');
          deleteRow(key);

          return response.text();
        }
    }).then(function(responseText) {
        console.log(responseText);
    }).catch(function(error) {
        alert('Error: ' + error.message);
    });

  }

}
